<template>
  <div>
    <div class="card p-4 shadow-sm">
      <!-- Toast de alerta -->
      <div
        v-if="mostrarToast"
        class="toast-container position-fixed top-0 end-0 p-3"
        style="z-index: 1055"
      >
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- Encabezado -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="m-0">Ingresos de productos a bodegas</h3>
        <button class="btn btn-success" @click="mostrarFormulario = true">Registrar Ingreso</button>
      </div>

      <!-- Formulario Registrar Compra -->
      <div v-if="mostrarFormulario" class="mb-4">
        <h5 class="mb-3">Nuevo Ingreso</h5>
        <div class="row g-4">
          <div class="col-md-3">
            <label class="form-label">Producto</label>
            <input v-model="busquedaProducto" type="text" class="form-control mb-1" placeholder="Buscar producto..." />
            <select v-model="nuevaCompra.IdProductoHotel" class="form-select">
              <option value="" disabled selected>Selecciona un producto</option>
              <option v-for="prod in productosFiltrados" :key="prod.IdProductoHotel" :value="prod.IdProductoHotel">
                {{ prod.NombreProducto }}
              </option>
            </select>
          </div>
          <div class="col-md-2">
            <label class="form-label">Cantidad</label>
            <input v-model.number="nuevaCompra.Cantidad" type="number" min="1" class="form-control" />
          </div>
        </div>
        <div class="text-end mt-3">
          <button class="btn btn-primary me-2" @click="guardarCompra">Registrar</button>
          <button class="btn btn-secondary" @click="cancelarFormulario">Cancelar</button>
        </div>
      </div>

      <!-- Tabla Compras -->
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Fecha</th>
              <th>Cantidad Ingresada</th>
              <th>Producto</th>
              <th>Empleado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="compras.length === 0">
              <td colspan="4">No hay ingresos realizados al inventario.</td>
            </tr>
            <tr v-for="compra in compras" :key="compra.IdCompraInventarioGeneralHotel">
              <td>{{ compra.FechaCompra }}</td>
              <td>{{ compra.Cantidad }}</td>
              <td>{{ compra.producto?.NombreProducto }}</td>
              <td>{{ compra.empleado?.Nombres }} {{ compra.empleado?.Apellidos }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";
import store from "@/store";

export default {
  name: "ComprasInventarioGeneralHotel",
  data() {
    return {
      compras: [],
      productos: [],
      busquedaProducto: "",
      mostrarFormulario: false,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      nuevaCompra: {
        IdProductoHotel: "",
        Cantidad: ""
      }
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    },
    empleadoId() {
      return store.getters.getUser?.IdEmpleado || null;
    },
    productosFiltrados() {
      const q = this.busquedaProducto.trim().toLowerCase();
      if (!q) return this.productos;
      return this.productos.filter(p => (p.NombreProducto || "").toLowerCase().includes(q));
    }
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerCompras() {
      try {
        const { data } = await axios.get(`${API_URL}/compras-inventario-general-hotel`);
        this.compras = data;
      } catch (error) {
        console.error(error);
      }
    },
    async obtenerProductos() {
      try {
        const { data } = await axios.get(`${API_URL}/inventario-general-hotel`);
        this.productos = data;
      } catch (error) {
        console.error(error);
      }
    },
    async guardarCompra() {
      const { IdProductoHotel, Cantidad } = this.nuevaCompra;
      if (!IdProductoHotel || !Cantidad) {
        this.mostrarAlerta("Todos los campos son obligatorios", "danger");
        return;
      }
      try {
        const payload = {
          IdProductoHotel,
          Cantidad,
          IdEmpleado: this.empleadoId
        };
        await axios.post(`${API_URL}/compras-inventario-general-hotel`, payload);
        this.mostrarAlerta("Ingreso registrado", "success");
        this.nuevaCompra = { IdProductoHotel: "", Cantidad: "" };
        this.mostrarFormulario = false;
        this.obtenerCompras();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al registrar ingreso", "danger");
      }
    },
    cancelarFormulario() {
      this.mostrarFormulario = false;
      this.nuevaCompra = { IdProductoHotel: "", Cantidad: "" };
    }
  },
  mounted() {
    this.obtenerCompras();
    this.obtenerProductos();
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: #fff;
  width: 450px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
</style>
